import React from 'react';

import { Section } from '../..';
import { defaultPropTypes } from '../AdditionalData';
import { checkSectionCondition } from '../../../Form.helpers';

const Gender = ({ field, translations }) => {
    const getVal = () => {
        switch (field.value) {
            case 'M':
                return translations.man;
            case 'F':
                return translations.woman;
            default: return null;
        }
    };
    const renderedSection = checkSectionCondition(getVal());

    return (
        <Section.Conditional
            condition={Boolean(field.order) && renderedSection}
            title={translations.gender}
        >
            {({ renderField }) => (
                renderField(null, getVal())
            )}
        </Section.Conditional>
    );
};
Gender.propTypes = defaultPropTypes;
export default Gender;
